import { Injectable } from '@angular/core';

import { fromEvent } from 'rxjs';

@Injectable()
export class ConfigService {
  setUpConfigurations(): void {
    this.#setViewportHeightDefinition();
    this.#subscribeOnScreenSizeChanges();
  }

  #subscribeOnScreenSizeChanges(): void {
    fromEvent(globalThis, 'resize').subscribe(() => this.#setViewportHeightDefinition());
  }

  /**
   * The `_setViewportHeightDefinition` method is used to redefine view height value
   * to fix height problem on mobile devices and tablets.
   */
  #setViewportHeightDefinition(): void {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
}
